import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { get } from 'lodash';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlanFocusedField } from 'store/useBusinessToolStore/selectors';

import { BottomSliderControlled } from 'components/_basic/BottomSlider';
import { InstructionsComponent } from 'components/_basic/InstructionsComponent';
import { Responsive } from 'components/_basic/Responsive';
import { getBusinessToolFieldsInstructions } from 'components/BusinessToolForm/Instructions';

import { InstructionButton } from './components';

export const InstructionsDecorator: React.FC = () => {
  const { i18n } = useTranslation();
  const focusedFieldName = useBusinessToolStore(getBusinessPlanFocusedField);

  const dataToShowRef = useRef(get(getBusinessToolFieldsInstructions(i18n.language), 'GLOBAL.companyName'));

  if (focusedFieldName) {
    const focusedFieldResult = get(getBusinessToolFieldsInstructions(i18n.language), focusedFieldName);
    if (focusedFieldResult) {
      dataToShowRef.current = get(getBusinessToolFieldsInstructions(i18n.language), focusedFieldName);
    }
  }

  return (
    <>
      <Responsive mobile>
        <BottomSliderControlled renderController={(onClick) => <InstructionButton onClick={onClick} />}>
          <InstructionsComponent {...dataToShowRef.current} />
        </BottomSliderControlled>
      </Responsive>
      <Responsive aboveMobile>
        <InstructionsComponent {...dataToShowRef.current} />
      </Responsive>
    </>
  );
};
